import * as React from "react"

import { cn } from "@/lib/utils"

type DivProps = React.ComponentProps<"div">

function MobileCard({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="mobile-card"
      className={cn(
        "flex flex-col gap-2 px-4 py-3 border-b last:border-b-0 text-sm",
        className,
      )}
      {...props}
    />
  )
}

function MobileCardHeader({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="mobile-card-header"
      className={cn("flex items-start justify-between gap-3", className)}
      {...props}
    />
  )
}

function MobileCardTitle({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="mobile-card-title"
      className={cn("font-medium text-sm min-w-0 flex-1", className)}
      {...props}
    />
  )
}

function MobileCardSubtitle({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="mobile-card-subtitle"
      className={cn("text-xs text-muted-foreground", className)}
      {...props}
    />
  )
}

function MobileCardMeta({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="mobile-card-meta"
      className={cn("grid grid-cols-2 gap-x-4 gap-y-1.5 text-xs", className)}
      {...props}
    />
  )
}

function MobileCardMetaItem({
  label,
  value,
  className,
}: {
  label: React.ReactNode
  value: React.ReactNode
  className?: string
}) {
  return (
    <div
      data-slot="mobile-card-meta-item"
      className={cn("flex flex-col gap-0.5 min-w-0", className)}
    >
      <span className="text-[0.65rem] uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      <span className="truncate">{value}</span>
    </div>
  )
}

function MobileCardFooter({ className, ...props }: DivProps) {
  return (
    <div
      data-slot="mobile-card-footer"
      className={cn("flex items-center justify-between gap-2 pt-1", className)}
      {...props}
    />
  )
}

export {
  MobileCard,
  MobileCardHeader,
  MobileCardTitle,
  MobileCardSubtitle,
  MobileCardMeta,
  MobileCardMetaItem,
  MobileCardFooter,
}
